import { render, staticRenderFns } from "./BundleContent.vue?vue&type=template&id=52522804&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./BundleContent.vue?vue&type=script&lang=js"
export * from "./BundleContent.vue?vue&type=script&lang=js"
import style0 from "./BundleContent.vue?vue&type=style&index=0&id=52522804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52522804",
  null
  
)

export default component.exports